import { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MessageCircle, Send } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { ADMIN_PATH, TELEGRAM, WHATSAPP } from "../../lib/api";
import { Brand } from "./Header";

export const Footer = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const clicks = useRef({ count: 0, timer: null });

  // Hidden admin entrance: triple-click on copyright text
  const onCopyrightClick = () => {
    clicks.current.count += 1;
    clearTimeout(clicks.current.timer);
    if (clicks.current.count >= 3) { clicks.current.count = 0; navigate(ADMIN_PATH); return; }
    clicks.current.timer = setTimeout(() => { clicks.current.count = 0; }, 700);
  };

  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div><Brand /><p>{t.footer.about}</p></div>
          <div>
            <h4>{t.footer.links}</h4>
            <div className="footer-links">
              <Link to="/" data-testid="footer-home-link">{t.nav.home}</Link>
              <Link to="/opportunities" data-testid="footer-opportunities-link">{t.nav.opportunities}</Link>
              <Link to="/achievements" data-testid="footer-achievements-link">{t.nav.achievements}</Link>
              <Link to="/coordinator" data-testid="footer-coordinator-link">{t.nav.coordinator}</Link>
              <Link to="/my" data-testid="footer-my-link">{t.nav.my}</Link>
            </div>
          </div>
          <div>
            <h4>{t.footer.contact}</h4>
            <div className="footer-links">
              <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link">WhatsApp · +966 56 165 3933</a>
              <a href={TELEGRAM} target="_blank" rel="noreferrer" data-testid="footer-telegram-link">Telegram · @Research_Network</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span className="copyright" onClick={onCopyrightClick} data-testid="footer-copyright">© 2026 RESEARCHNETWORK · {t.footer.rights}</span>
          <span>Riyadh · KSA</span>
        </div>
      </div>
    </footer>
  );
};

export const Floaters = () => (
  <div className="floaters" data-testid="floating-contact">
    <a className="floater wa" href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="floating-whatsapp" aria-label="WhatsApp"><MessageCircle size={24} /></a>
    <a className="floater tg" href={TELEGRAM} target="_blank" rel="noreferrer" data-testid="floating-telegram" aria-label="Telegram"><Send size={21} /></a>
  </div>
);
